import { c as _c } from "react/compiler-runtime";
import EmailStatisticsCharts from 'modules/email-statistics/components/email-statistics-charts';
import EmailStatisticsFilter from 'modules/email-statistics/components/email-statistics-filter';
import EmailStatisticsPool from 'modules/email-statistics/components/email-statistics-pool';
import EmailStatisticsTable from 'modules/email-statistics/components/email-statistics-table';
import { EmailStatisticsLoco } from 'modules/email-statistics/constants/email-statistics-loco';
import { EmailStatisticsFilterInterface } from 'modules/email-statistics/types/email-statistics-interface';
import { NextPage } from 'next';
import React from 'react';
import { SectionMessage } from 'shared/components/section-message';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useFilterWithDate } from 'shared/route-query/hooks/use-filter/use-filter-with-date';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { getMonthDateRange } from 'shared/utils/get-dates';
const defaultFilter: EmailStatisticsFilterInterface = {
  dateSince: null,
  dateTill: null
};
const EmailStatistics: NextPage = () => {
  const $ = _c(21);
  const {
    t
  } = useLocoTranslation();
  const {
    filter,
    setFilter
  } = useFilterWithDate(defaultFilter, getMonthDateRange);
  let t0;
  if ($[0] !== t) {
    t0 = t("dashboard.email_statistics.email_statistics");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h1>{t0}</h1>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("dashboard.email.new_google_policy_warning_message");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <SectionMessage>{t2}</SectionMessage>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <EmailStatisticsPool />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== filter || $[10] !== setFilter) {
    t5 = <div className="flex flex-col justify-between gap-3 sm:flex-row">{t4}<EmailStatisticsFilter filter={filter} setFilter={setFilter} /></div>;
    $[9] = filter;
    $[10] = setFilter;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  let t7;
  if ($[12] !== filter) {
    t6 = <div><EmailStatisticsCharts filter={filter} /></div>;
    t7 = <div><EmailStatisticsTable filter={filter} /></div>;
    $[12] = filter;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t1 || $[16] !== t3 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className="flex flex-col gap-5">{t1}{t3}{t5}{t6}{t7}</div>;
    $[15] = t1;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
export const getServerSideProps = getBaseServerSideProps(EmailStatisticsLoco, 'header.top_menu.email_statistics');
export default EmailStatistics;